<div
  [class.d-none]="loading"
  class="card-body tw-flex-center tw-px-0 flex-column"
>
  <div class="chart-container">
    <canvas [id]="chartId" [class]="isResponsive ? 'responsive-chart' : ''">{{
      chart
    }}</canvas>
  </div>

  <!-- preloading -->
  <div class="row tw-justify-center" *ngIf="loading">
    <div class="tw-mt-[23px] tw-w-full tw-justify-center">
      <div class="tw-flex tw-my-2 tw-items-center tw-justify-center">
        <div class="bg-preloading tw-mx-2 titr-preloading"></div>
      </div>
    </div>
    <div class="tw-w-full bg-preloading Rectangle-chart-preloading"></div>
  </div>
</div>
